import { render, staticRenderFns } from "./thirdImpr.vue?vue&type=template&id=6226ed6a"
import script from "./thirdImpr.vue?vue&type=script&lang=js"
export * from "./thirdImpr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6226ed6a')) {
      api.createRecord('6226ed6a', component.options)
    } else {
      api.reload('6226ed6a', component.options)
    }
    module.hot.accept("./thirdImpr.vue?vue&type=template&id=6226ed6a", function () {
      api.rerender('6226ed6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/third/risk/thirdImpr.vue"
export default component.exports